import { convertPriceStringToInteger } from "@shared/modules/financials/utils/price-utils";
import { PaymentServiceBasket } from "../../services/useBasketPaymentService";

export const isShowpassBasketGateway = (basket: PaymentServiceBasket) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- serializer false positive
    convertPriceStringToInteger(basket.totalPrice!) === 0 ||
    // On waitlist baskets, not requiring cc verification means we don't need to capture payment method details
    // to process being added to a waitlist, hence a free gateway.
    (basket.isWaitlist &&
      "waitlist" in basket &&
      basket.waitlist &&
      !basket.waitlist.cc_verification_required)
  );
};
